import { useRouter } from "@tanstack/react-router";

import { Icon } from "@shared/ui/chakra";
import { EmptyState } from "@shared/ui/templates/empty-state";

import { useNotFoundMessages } from "./hooks/use-not-found-messages";

export const NotFoundPageConnector = () => {
  const router = useRouter();
  const { buttonText, subtitle, title } = useNotFoundMessages();

  const handleGoHome = async () => {
    await router.navigate({ to: "/" });
  };

  return (
    <EmptyState
      buttonText={buttonText}
      iconSlot={
        <Icon color="fg.subtle" name="File" size="2xl" variant="frame" />
      }
      subtitle={subtitle}
      title={title}
      onAction={handleGoHome}
    />
  );
};
